import { useAdvertiserAccess } from '@/flight-deck-api/services/advertisers.service'
import { FlightDeckSessionSync } from './flight-deck-session-sync'

export type AdvertiserAccessGateProps = {
  children: React.ReactNode
  fallback: React.ReactNode | null
  session?: {
    advertiser: {
      id: number | undefined
      name?: string | undefined
      logo?: string | undefined | null
    }
  } | null
}

/** @deprecated - use FlightDeckAccessGuard instead. Will be deleted once premier-ui migrates. */
const AdvertiserAccessGate = ({ children, fallback, session }: AdvertiserAccessGateProps) => {
  const advertiserId = session?.advertiser?.id

  const { data: advertiserAccess } = useAdvertiserAccess(advertiserId)

  const hasAccess = advertiserAccess.data.flightDeck

  return (
    <>
      <FlightDeckSessionSync />
      {hasAccess ? children : fallback}
    </>
  )
}

// biome-ignore lint/style/noDefaultExport: RETIRED, do not copy. Use a named export when touching this.
export default AdvertiserAccessGate
